import { getCartItems } from "store/selectors";

const getNormalizedCartItems = (state) => {
  const cartItems = getCartItems(state);

  return cartItems.reduce((acc, cartItem) => {
    cartItem.lines.forEach((line) => {
      acc.push({
        name: line.text,
        coupon: line.coupon,
        price: line.price,
        discountedPrice: line.rebatePrice,
        category: line.category,
        category2: line.category2,
        category3: line.category3,
        quantity: line.renewalPrice / line.unitPrice, // because there is no quantity in the cart item... is there any better way to do this?
        variant: line.variant,
      });
    });
    return acc;
  }, []);
};

export default getNormalizedCartItems;
